var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('h6',[_vm._v("Included Environments")])]),_c('v-col',_vm._l((_vm.single_pretarget.includedEnvironments),function(item,i){return _c('h6',{key:i,staticClass:"text-caption"},[_vm._v(" "+_vm._s(_vm.capitalizeFirstLetter(item.toLowerCase()))+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }